import {
  Button,
  Drawer,
  Heading,
  Positions,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { ChevronRight } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { useParams } from 'react-router';
import { useStore } from 'store';

const MobileCompanySiteSwitch = ({
  name,
  onClick,
}: {
  name: string | undefined;
  onClick: () => void;
}) => {
  return (
    <Button
      size={Sizes.Large}
      fullWidth={true}
      icon={<ChevronRight />}
      iconPosition={Positions.Right}
      variant="outlined"
      data-testid="navbar-modal-button"
      onClick={onClick}
    >
      {name ?? '-'}
    </Button>
  );
};

export const MobileCompanySiteDrawer = ({
  companyName,
  companyHasMultipleSites,
}: {
  companyName: string | undefined;
  companyHasMultipleSites: boolean;
}) => {
  const [
    selectedSite,
    setMobileCompanySiteDrawerClosed,
    setCompanyModalOpen,
    setSiteModalOpen,
  ] = useStore((state) => [
    state.selectedSite,
    state.setMobileCompanySiteDrawerClosed,
    state.setCompanyModalOpen,
    state.setSiteModalOpen,
  ]);

  const { company } = useParams();

  return (
    <Drawer
      data-testid="mobile-company-drawer"
      header={{ title: 'Switch company & site' }}
      size={Sizes.Small}
      open
      placement={Positions.Bottom}
      onClose={setMobileCompanySiteDrawerClosed}
      mask
      elevation={true}
      padding={true}
      style={{ paddingBottom: '36px' }}
    >
      {company ? (
        <>
          <Heading level={4} bold>
            Company
          </Heading>
          <Heading
            level={4}
            bold
            style={{ paddingLeft: '12px', marginTop: '20px' }}
          >
            <MobileCompanySiteSwitch
              name={companyName}
              onClick={() => {
                setCompanyModalOpen();
                setMobileCompanySiteDrawerClosed();
              }}
            />
          </Heading>
        </>
      ) : null}
      <>
        <Heading level={4} bold style={{ marginTop: '24px' }}>
          Site
        </Heading>
        <Heading
          level={4}
          bold
          style={{ paddingLeft: '12px', marginTop: '20px' }}
        >
          {companyHasMultipleSites ? (
            <MobileCompanySiteSwitch
              name={selectedSite}
              onClick={() => {
                setSiteModalOpen();
                setMobileCompanySiteDrawerClosed();
              }}
            />
          ) : (
            selectedSite
          )}
        </Heading>
      </>
    </Drawer>
  );
};
